import Glide from '@glidejs/glide';

export const C__MediaCarousel = () => ({
    lightboxOpenedHandler: null,
    lightboxClosedHandler: null,

    start(settings) {
        var elem = this.$el.querySelector('.glide');
        const glide = new Glide(elem, {
            type: 'carousel',
            startAt: 0,
            perView: 1,
            autoplay: parseInt(settings.autoplay_interval || 0) // Default to 0 if autoplay_interval is undefined
        }).mount();

        // Define event handlers
        this.lightboxOpenedHandler = (event) => {
            glide.pause();
        };

        this.lightboxClosedHandler = (event) => {
            glide.play();
        };

        // Add event listeners
        document.addEventListener('lightboxOpened', this.lightboxOpenedHandler);
        document.addEventListener('lightboxClosed', this.lightboxClosedHandler);
    },

    destroy() {
        // Remove event listeners
        if (this.lightboxOpenedHandler) {
            document.removeEventListener(
                'lightboxOpened',
                this.lightboxOpenedHandler
            );
        }
        if (this.lightboxClosedHandler) {
            document.removeEventListener(
                'lightboxClosed',
                this.lightboxClosedHandler
            );
        }
    }
});
